<div *ngIf="start == true">

  <mat-card class="card-primary" *ngIf="!flag" style="background-color: white">
    <mat-card-content>
      <img src="https://www.cpcesfe2.org.ar/wp-content/themes/consejo/img/logo.png" alt="">
      <h2 style="text-align: center">
        Esta encuesta ya no se encuentra disponible
      </h2>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="flag" class="card-primary mat-elevation-z" style="background-color: white">
    <mat-card-content *ngIf="questions">
      <img src="https://www.cpcesfe2.org.ar/wp-content/themes/consejo/img/logo.png" alt="">
      <h2>Encuesta de satisfacción – Capacitaciones / Formaciones</h2>
      <p>
        Tu opinión es muy importante para seguir mejorando nuestras propuestas formativas.
        Agradecemos tu tiempo y tu participación.
      </p>

      <div class="question" *ngFor="let q of questions; index as i">

        <!-- Escalas -->
        <div *ngIf="q.type === 'scale'" class="ask escala">
          {{ q.name }}
          <div class="escalas" [ngClass]="getEscalaClass(q.value)">
            <div class="item" *ngFor="let val of [].constructor(q.scale.max - q.scale.min + 1); let idx = index"
              [ngClass]="{ active: q.value === q.scale.min + idx }" (click)="update(i, q.scale.min + idx)">
              <p>{{ q.scale.min + idx }}</p>
            </div>
          </div>
          <!-- <div class="informativo" *ngIf="q.value !== undefined">
            <p>
              Usted ha dado una puntuación <span>{{q.value}}</span>
              <button *ngIf="step < 0.5" style="top: -6px; left: 6px; background-color: #e55750;" mat-flat-button
                color="primary" (click)="toContinue()">Continuar</button>
            </p>
          </div> -->
        </div>

        <!-- Boolean -->
        <div *ngIf="q.type === 'boolean'" class="ask">
          {{ q.name }}
          <mat-radio-group [(ngModel)]="q.value" aria-label="Select Yes or No">
            <mat-radio-button [value]="true">Sí</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>

        <!-- Grupo de subpreguntas -->
        <div *ngIf="q.type === 'group'" class="ask group">
          <div>{{ q.name }}</div>
          <div *ngFor="let subItem of q.subitems; let subIndex = index" class="ask escala">
            {{ subItem.label }}
            <div class="escalas" [ngClass]="getEscalaClass(q.value[subIndex])">
              <div class="item" *ngFor="let val of [].constructor(q.scale.max - q.scale.min + 1); let idx = index"
                [ngClass]="{ active: q.value[subIndex] === q.scale.min + idx }"
                (click)="updateGroup(i, subIndex, q.scale.min + idx)">
                <p>{{ q.scale.min + idx }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Lista -->
        <div *ngIf="q.type === 'list'" class="ask">
          {{ q.name }}
          <mat-radio-group [(ngModel)]="q.value" aria-label="Select an option" class="radios">
            <mat-radio-button *ngFor="let opt of q.options" [value]="opt.value">
              {{ opt.label }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <!-- Texto corto -->
        <div *ngIf="q.type === 'text'" class="ask">
          {{ q.name }}
          <input type="text" [(ngModel)]="q.value" />
        </div>

        <!-- Texto largo -->
        <div *ngIf="q.type === 'textarea'" class="ask">
          <span *ngIf="q.name != 'Pregunta abierta de NPS'">
            {{ q.name }}
          </span>
          <ng-container *ngIf="q.name == 'Pregunta abierta de NPS'  ">
            {{this.questions[0].value}}
            <span *ngIf=" this.questions[0].value < 7">
              ¿Por qué no nos recomendarías?
            </span>
            <span *ngIf="this.questions[0].value > 6 && this.questions[0].value < 9">
              ¿Qué aspectos deberíamos mejorar para que nos recomendaras más?
            </span>
            <span *ngIf="this.questions[0].value > 8 ">
              ¿Qué aspectos destacas cuando nos recomiendas?
            </span>
          </ng-container>


          <textarea [(ngModel)]="q.value"></textarea>
        </div>

      </div>

      <div>
        <button (click)="save()" class="float-right" mat-flat-button color="primary">
          Guardar
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<div *ngIf="start == false">
  <mat-spinner color="secondary"></mat-spinner>
</div>